import React from "react";
import PropTypes from "prop-types";

const Accordion = ({ ...props }) => (
	<>
		<div className={`accordion-container ${props.isActive ? "active" : ""}`}>
			<button type="button" className="accordion-head" onClick={() => props.toggleAccordion(props.id)}>
				{props.title}
			</button>
			<div className="accordion-body">
				{props.children}
			</div>
		</div>

		<style jsx>
			{`
        .accordion-container {
          width: 100%;
          background: #FFFFFF;
        }

        .accordion-head {
          border: none;
          background: none;
          width: 100%;
          text-align: left;
          padding: ${props.padding};
          border-bottom: 1px solid #DFE3E8;
          position: relative;
        }

        .accordion-head::after {
          content: url("https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/chevron-down.svg");
          position: absolute;
          right: 5.25px;
          top: 50%;
          transform: translateY(-50%);
        }

        .accordion-container.active > .accordion-head {
          border-bottom: none;
        }

        .accordion-container.active > .accordion-head::after {
          content: url("https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/icon/chevron-up.svg");
        }

        .accordion-body {
          display: none;
        }

        .accordion-container.active > .accordion-body {
          display: block;
        }
      `}
		</style>
	</>
);

Accordion.propTypes = {
	title: PropTypes.element,
	children: PropTypes.element,
	padding: PropTypes.string,
	isActive: PropTypes.bool,
	toggleAccordion: PropTypes.func,
};

Accordion.defaultProps = {
	title: <></>,
	children: <></>,
	padding: "17px 0px",
	isActive: false,
	toggleAccordion: () => false,
};

export default Accordion;
